import { useSelector } from 'react-redux';
import { Button } from 'foundations-components/transitional/components/Button';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { useUpgradeModalInIframe } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getHasAudioNarrationAccess
// @ts-expect-error Not migrated yet
} from '../../redux/selectors/authSelectors';
import { UPGRADE_POINT_KEY } from '../../constants/audioNarration';
import { jsx as _jsx } from "react/jsx-runtime";
const NarrationFeatureBadge = () => {
  const hasAudioNarrationAccess = useSelector(getHasAudioNarrationAccess);
  const {
    openUpgradeModal
  } = useUpgradeModalInIframe(UPGRADE_POINT_KEY);
  if (hasAudioNarrationAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    onClick: openUpgradeModal,
    use: "transparent",
    children: /*#__PURE__*/_jsx(LockBadge, {})
  });
};
export default NarrationFeatureBadge;